import { render, staticRenderFns } from "./orderProduct.vue?vue&type=template&id=44507a00&scoped=true"
import script from "./orderProduct.vue?vue&type=script&lang=js"
export * from "./orderProduct.vue?vue&type=script&lang=js"
import style0 from "./orderProduct.vue?vue&type=style&index=0&id=44507a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44507a00",
  null
  
)

export default component.exports